import React, { useCallback, useState } from 'react';
import SignUp from '../SignUp';
import FormHeader from '../FormHeader';
import InvestorPricingPlans from './InvestorPricingPlans';
import { isUnitedStatesCountry } from '../../utils/investorPricingView';
import type { InvestorPlanId } from '../../constants/investorPricingPlans';
import { SUCCESS_FEE_LIVE } from '../../constants/successFee';

interface InvestorSignupContentProps {
  pricingType: 'yearly' | 'lifetime' | 'threeYear';
  onPricingTypeChange: (type: 'yearly' | 'lifetime' | 'threeYear') => void;
  onPromoCodeValid: (isValid: boolean) => void;
}

const InvestorSignupContent: React.FC<InvestorSignupContentProps> = ({
  pricingType,
  onPricingTypeChange,
  onPromoCodeValid,
}) => {
  const [country, setCountry] = useState('');
  const hideSuccessFee = !SUCCESS_FEE_LIVE || isUnitedStatesCountry(country);

  const handleCountryChange = useCallback((nextCountry: string) => {
    setCountry(nextCountry);
  }, []);

  const handleSelectPlan = useCallback(
    (planId: InvestorPlanId) => {
      onPricingTypeChange(planId);
      document
        .querySelector('.investor-signup-form')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    [onPricingTypeChange]
  );

  return (
    <div
      className="investor-pricing-page pt-10 md:pt-8 lg:pt-8 pb-20 md:pb-24 text-left"
      style={{ backgroundColor: '#262626' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)] gap-8 xl:gap-10 xl:items-start">
          <div className="order-1 w-full min-w-0 self-start">
            <InvestorPricingPlans hideSuccessFee={hideSuccessFee} onSelectPlan={handleSelectPlan} />
          </div>

          <div className="order-2 w-full min-w-0 flex justify-center xl:justify-end self-start investor-signup-form">
            <div className="w-full max-w-lg min-w-0 mx-auto lg:mx-0">
              <div
                className="overflow-hidden rounded-3xl border border-gray-700/30 bg-black/50 p-5 shadow-xl [container-type:inline-size] sm:p-6 lg:p-7"
                data-selected-plan={pricingType}
              >
                <FormHeader
                  title="Join PRAIRI as an Investor"
                  subtitle=""
                  compact
                  align="center"
                  headingLevel="h2"
                  titleClassName="max-w-full whitespace-nowrap text-[clamp(16px,6.6cqi,26px)] font-bold leading-tight text-white mb-3 text-center"
                />
                <div className="mt-3">
                  <SignUp
                    userType="investor"
                    pricingType={pricingType}
                    onPromoCodeValid={onPromoCodeValid}
                    onCountryChange={handleCountryChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorSignupContent;
